<template>
     <div class="bg-image">
          <div class="row g-0 justify-content-center bg-primary-dark-op">
            <div class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0">
              <!-- Reminder Block -->
              <div class="block block-transparent block-rounded w-100 mb-0 overflow-hidden">
                <div class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-body-extra-light">
                  <!-- Header -->
                  <div class="mb-2 text-center">
                    <router-link class="link-fx fw-bold fs-1" :to="{name:'login'}">
                      <span class="text-dark">Save</span><span class="text-primary">Control</span>
                    </router-link>
                    <p class="text-uppercase fw-bold fs-sm text-muted">Reinciar Contraseña</p>
                  </div>
                  <!-- END Header -->

                  <!-- Reminder Form -->
                  <!-- jQuery Validation (.js-validation-reminder class is initialized in js/pages/op_auth_reminder.min.js which was auto compiled from _js/pages/op_auth_reminder.js) -->
                  <!-- For more info and examples you can check out https://github.com/jzaefferer/jquery-validation -->
                  <div class="js-validation-reminder">
                    <div class="mb-4">
                      <div class="input-group input-group-lg">
                        <input 
                        v-model="data.user.email"
                        type="text" class="form-control" id="reminder-credential" name="reminder-credential" placeholder="Correo Electronico">
                        <span class="input-group-text">
                          <i class="fa fa-user-circle"></i>
                        </span>
                      </div>
                    </div>
                    <div class="text-center mb-4">
                      <button type="submit" class="btn btn-hero btn-primary"
                      @click="check_form()"
                      >
                        <i class="fa fa-fw fa-reply opacity-50 me-1"></i>Reiniciar Contraseña
                      </button>
                    </div>
                </div>
                  <!-- END Reminder Form -->
                </div>
              </div>
              <!-- END Reminder Block -->
            </div>
          </div>
        </div>
    
</template>

<script setup>
import passwordReset from '@/composables/usePasswordReset'
const {data, check_form} = passwordReset()
</script>